export const dialogContentStyles = {
  display: 'flex',
  flexDirection: 'row',
};

export const dialogIconStyles = {
  color: '#FBAD33',
  fontSize: '4rem',
  marginRight: '26px',
};

export const dialogTitleStyles = {
  fontFamily: 'Roboto',
  fontSize: '16px',
  fontWeight: '500',
  lineHeight: '22px',
  letterSpacing: '0.15px',
  textAlign: 'left',
};
